import './partnercarousel';